exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-905c94d8] .el-tabs__content{padding:10px}", ""]);

// exports
